import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { ConfigurationService } from './configuration.service';

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategyService extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly configurationService = inject(ConfigurationService);

  override updateTitle() {
    const appName = this.configurationService.configuration[
      'appName'
    ] as unknown as string;
    this.title.setTitle(appName + ' | Group Sales - 3D Digital Venue ');
  }
}
